import * as React from 'react'
import { bundleIcon, CircleHintHalfVerticalFilled } from '@fluentui/react-icons'
import { makeStyles, tokens } from '@fluentui/react-components'

const OpeningIcon = bundleIcon(CircleHintHalfVerticalFilled, CircleHintHalfVerticalFilled)

const useStyles = makeStyles({
    loading: {
        color: tokens.colorBrandStroke1,
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: tokens.curveEasyEase,
        animationName: 'spinner',
    },
})

export default function LoadingIcon() {
    const styles = useStyles()

    return <OpeningIcon className={styles.loading} />
}
